@use "../../styles/breakpoint.module.scss" as *;

.mediaInner {
    display: flex;
    justify-content: space-between;
    gap: var(--spacer-32);
    padding-bottom: var(--spacer-32);

    @media ($below-mobile) {
        flex-direction: column;
    }

    [data-design-version="v2026"] & {
        align-items: center;
        border-top: 1px solid var(--gray-700);
        padding-top: var(--spacer-24);
        padding-bottom: var(--spacer-24);

        @media ($below-mobile) {
            align-items: stretch;
            gap: 0;
        }
    }
}

.iconContainer {
    display: flex;
    flex-direction: column;

    @media ($below-mobile) {
        align-items: center;
    }
}

.iconTitle {
    composes: fontUppercase from "../../styles/composable/typography.module.css";
    margin-bottom: var(--spacer-16);

    p {
        font: var(--font-eyebrow);
    }

    [data-design-version="v2026"] & {
        display: none;
    }
}

.iconBlock {
    display: flex;
    gap: var(--spacer-12);

    [data-design-version="v2026"] & {
        gap: var(--spacer-40);

        @media ($below-mobile) {
            width: 100%;
            justify-content: space-between;
            gap: 0;
            padding-bottom: var(--spacer-16);
            border-bottom: 1px solid var(--gray-700);
        }
    }
}

.footerIcons {
    fill: var(--white);

    svg {
        width: var(--spacer-32);
        height: var(--spacer-32);
    }

    [data-design-version="v2026"] & svg {
        width: var(--spacer-24);
        height: var(--spacer-24);

        @media ($below-mobile) {
            width: var(--spacer-32);
            height: var(--spacer-32);
        }
    }
}

.selectContainer {
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;

    @media ($below-mobile) {
        justify-content: center;
    }

    [data-design-version="v2026"] & {
        cursor: pointer;
        max-width: 200px;

        @media ($below-mobile) {
            justify-content: flex-start;
            padding-block: var(--spacer-16);
            border-bottom: 1px solid var(--gray-700);
            max-width: 100%;
        }
    }
}

.select {
    width: 100%;
    max-width: 280px;

    [data-design-version="v2026"] & {
        @media ($below-mobile) {
            max-width: 100%;
        }
    }
}

.selectButton {
    composes: outline from "../../styles/composable/utility.module.css";
    cursor: pointer;
    position: relative;
    width: 100%;
    padding: var(--spacer-4) var(--spacer-12);
    background-color: var(--black);
    border: 1px solid var(--white);
    color: var(--white);
    font: var(--font-p-14);
    text-align: left;

    [data-design-version="v2026"] & {
        border: 0;
        border-bottom: 1px solid var(--off-white);
        padding: 0 var(--spacer-24) var(--spacer-8) 0;
        font: var(--font-nav-14);
        letter-spacing: 0.03em;
        color: var(--off-white);

        @media ($below-mobile) {
            border-bottom: none;
        }
    }
}

.downCaret {
    position: absolute;
    top: 50%;
    right: var(--spacer-12);
    width: 16px;
    height: 16px;
    fill: currentColor;
    rotate: 90deg;
    translate: 0 -50%;

    [data-design-version="v2026"] & {
        right: 0;
        rotate: 90deg;
        fill: var(--off-white);
    }
}

.popover {
    background-color: var(--black);
    border: 1px solid var(--white);
    color: var(--white);

    &[data-trigger="Select"] {
        width: var(--trigger-width);
    }

    [data-design-version="v2026"] & {
        border-color: var(--gray-700);
    }
}

.listBox {
    composes: outline from "../../styles/composable/utility.module.css";
}

.listBoxItem {
    composes: outline from "../../styles/composable/utility.module.css";
    padding: var(--spacer-4) var(--spacer-8);
    cursor: pointer;
    font: var(--font-p-14);

    &:hover {
        background-color: var(--dark-brown);
    }

    [data-design-version="v2026"] &:hover {
        background-color: var(--gray-900);
    }
}
